import { BrowserRouter } from 'react-router-dom'
import './App.css'
import RouterMain from './routers/RouterMain';
import AuthState from './context/auth/authState';
//import AuthState from './context/auth/authState';
import "bootstrap/dist/js/bootstrap.min.js"
import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
import { DATADOG_APPID, DATADOG_CLIENTTOKEN, DATADOG_ENV, DATADOG_SERVICE, DATADOG_SITE } from './environment/variables';

function App() {

  useEffect(() => {
    if(DATADOG_ENV=='prod'){
      datadogRum.init({
        applicationId: DATADOG_APPID,
        clientToken: DATADOG_CLIENTTOKEN,
        site: DATADOG_SITE,
        service: DATADOG_SERVICE,
        env: DATADOG_ENV,
        sessionSampleRate: 50,
        sessionReplaySampleRate: 10,
        defaultPrivacyLevel: 'mask-user-input',
        trackResources: true
      });
      datadogRum.startSessionReplayRecording();
    }
  }, [])
  return (
    <>
      <div>
        <BrowserRouter>
          <AuthState>
            <RouterMain />
          </AuthState>
        </BrowserRouter>
      </div>
    </>
  );
}

export default App
